<div class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">
    <!-- Header -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">โซนลานจอด</h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการข้อมูลโซน ชั้นลานจอด และประเภทการจอดรถ
            </p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 dark:text-slate-400 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all active:scale-95 flex items-center justify-center">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="navigateToCreate()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-2xl hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2">
                <span class="material-icons text-xl">add_circle</span>
                สร้างโซนใหม่
            </button>
        </div>
    </div>

    <!-- Stats Box Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div *ngFor="let stat of dashboardStats; let i = index"
            class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-slate-100/50 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
            [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl group-hover:scale-110 transition-transform">{{ stat.icon
                        }}</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                </h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}
                </div>
            </div>
        </div>
    </div>

    <!-- Table Container -->
    <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden"
        style="animation-delay: 0.2s;">

        <!-- Control Bar -->
        <div class="p-6 border-b border-slate-100/50 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">grid_view</span>
                รายการโซนลานจอด
            </h3>

            <div class="flex flex-col xl:flex-row items-center gap-3 w-full xl:w-auto">
                <div class="flex gap-2 w-full xl:w-auto">
                    <!-- Floor Filter -->
                    <div class="relative min-w-[150px]">
                        <button (click)="toggleFloorDropdown()"
                            class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100 rounded-xl h-[42px] shadow-sm text-sm font-bold text-slate-600 outline-none transition-all"
                            [ngClass]="isFloorDropdownOpen ? 'ring-2 ring-amber-200' : ''">
                            <span class="flex items-center gap-2">
                                <span class="material-icons text-[18px] text-slate-400">layers</span>
                                {{ filterFloor === '' ? 'ทุกชั้น' : filterFloor }}
                            </span>
                            <span class="material-icons text-slate-400 text-[16px] transition-transform"
                                [class.rotate-180]="isFloorDropdownOpen">expand_more</span>
                        </button>

                        <button *ngIf="isFloorDropdownOpen" class="fixed inset-0 cursor-default z-30 opacity-0"
                            (click)="toggleFloorDropdown()"></button>

                        <div *ngIf="isFloorDropdownOpen"
                            class="absolute top-full left-0 mt-2 w-[180px] bg-white rounded-2xl shadow-xl border border-slate-100 py-2 z-40 animate-fade-in-up">
                            <div (click)="selectFloor('')"
                                class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer transition-colors"
                                [ngClass]="filterFloor === '' ? 'text-amber-500 bg-amber-50' : 'text-slate-600'">ทุกชั้น
                            </div>
                            <div *ngFor="let f of floorOptions" (click)="selectFloor(f)"
                                class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer transition-colors"
                                [ngClass]="filterFloor === f ? 'text-amber-500 bg-amber-50' : 'text-slate-600'">{{ f }}
                            </div>
                        </div>
                    </div>

                    <!-- Parking Type Filter -->
                    <div class="relative min-w-[180px]">
                        <button (click)="toggleParkingTypeDropdown()"
                            class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100 rounded-xl h-[42px] shadow-sm text-sm font-bold text-slate-600 outline-none transition-all"
                            [ngClass]="isParkingTypeDropdownOpen ? 'ring-2 ring-amber-200' : ''">
                            <span class="flex items-center gap-2">
                                <span class="material-icons text-[18px] text-slate-400">directions_car</span>
                                {{ filterParkingType === '' ? 'ทุกประเภท' : filterParkingType }}
                            </span>
                            <span class="material-icons text-slate-400 text-[16px] transition-transform"
                                [class.rotate-180]="isParkingTypeDropdownOpen">expand_more</span>
                        </button>

                        <button *ngIf="isParkingTypeDropdownOpen" class="fixed inset-0 cursor-default z-30 opacity-0"
                            (click)="toggleParkingTypeDropdown()"></button>

                        <div *ngIf="isParkingTypeDropdownOpen"
                            class="absolute top-full right-0 mt-2 w-[220px] bg-white rounded-2xl shadow-xl border border-slate-100 py-2 z-40 animate-fade-in-up">
                            <div (click)="selectParkingType('')"
                                class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer transition-colors"
                                [ngClass]="filterParkingType === '' ? 'text-amber-500 bg-amber-50' : 'text-slate-600'">
                                ทุกประเภท</div>
                            <div *ngFor="let pt of parkingTypeOptions" (click)="selectParkingType(pt)"
                                class="px-4 py-2 text-sm font-bold hover:bg-amber-50 cursor-pointer transition-colors"
                                [ngClass]="filterParkingType === pt ? 'text-amber-500 bg-amber-50' : 'text-slate-600'">
                                {{ pt }}</div>
                        </div>
                    </div>
                </div>

                <!-- Search box -->
                <div class="relative flex-1 flex w-full xl:min-w-[300px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[42px]">
                        <span class="absolute left-3 material-icons text-slate-400 text-[20px]">search</span>
                        <input type="text" placeholder="ค้นหาชื่อ, ชั้น..." [(ngModel)]="searchText"
                            (input)="onSearch()"
                            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-600 focus:ring-0 focus:outline-none placeholder:text-slate-400">
                    </div>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto min-h-[400px] relative custom-scrollbar">

            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading"
                [class.pointer-events-none]="isLoading">
                <thead class="sticky top-0 z-20 bg-white/95 backdrop-blur-sm shadow-sm border-b border-slate-100/50">
                    <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
                        <th class="p-4 w-[60px] text-center">
                            <div class="flex items-center justify-center">
                                <div (click)="toggleAllSelection()"
                                    class="w-5 h-5 rounded flex items-center justify-center transition-all border cursor-pointer select-none"
                                    [ngClass]="isAllSelected() ? 'bg-amber-400 border-amber-400 text-white' : 'bg-white border-slate-300 text-transparent hover:border-amber-400'">
                                    <span class="material-icons text-[14px] font-black">check</span>
                                </div>
                            </div>
                        </th>
                        <th (click)="sortData('id')" class="p-4 cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center gap-1">ID<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'id'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('name')" class="p-4 cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center gap-1">ชื่อโซน<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'name'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('floor')" class="p-4 cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center gap-1">ชั้น<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'floor'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('parkingType')" class="p-4 cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center gap-1">ประเภทการจอดรถ<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'parkingType'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('lot')" class="p-4 text-center cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center justify-center gap-1">จำนวนที่จอด<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'lot'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('isOnline')"
                            class="p-4 text-center cursor-pointer hover:text-slate-600 group">
                            <div class="flex items-center justify-center gap-1">สถานะ<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500"
                                    [class.opacity-100]="sortColumn === 'isOnline'">{{ sortDirection === 'asc' ?
                                    'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50">
                    <tr *ngFor="let p of filteredList; let i = index" (click)="openEditModal(p)"
                        class="animate-fade-in-up group transition-colors duration-200 cursor-pointer"
                        [ngClass]="isSelected(p.id) ? 'bg-amber-50/60' : 'hover:bg-slate-50/50'">

                        <td class="p-4 text-center" (click)="$event.stopPropagation()">
                            <div class="flex items-center justify-center">
                                <div (click)="toggleSelection(p.id, $event)"
                                    class="w-5 h-5 rounded flex items-center justify-center transition-all border cursor-pointer select-none"
                                    [ngClass]="isSelected(p.id) ? 'bg-amber-400 border-amber-400 text-white' : 'bg-white border-slate-300 text-transparent hover:border-amber-400'">
                                    <span class="material-icons text-[14px] font-black">check</span>
                                </div>
                            </div>
                        </td>

                        <td class="p-4 font-mono text-sm text-slate-600 font-bold">{{ p.id }}</td>

                        <td class="p-4 text-sm font-bold text-slate-700">{{ p.name }}</td>

                        <td class="p-4">
                            <div
                                class="inline-flex items-center px-3 py-1 bg-indigo-50 text-indigo-600 text-xs font-bold rounded-lg">
                                {{ p.floor }}</div>
                        </td>

                        <td class="p-4 text-slate-600 font-medium">{{ p.parkingType }}</td>

                        <td class="p-4 text-center text-slate-700 font-bold">{{ p.lot | number }}</td>

                        <td class="p-4 text-center" (click)="$event.stopPropagation()">
                            <div class="flex justify-center">
                                <div class="relative inline-flex items-center cursor-pointer"
                                    (click)="toggleStatusLive(p)">
                                    <input type="checkbox" class="sr-only peer" [checked]="p.isOnline">
                                    <div
                                        class="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500 rounded-full shadow-inner">
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="filteredList.length === 0 && !isLoading">
                        <td [attr.colspan]="7" class="py-20 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div class="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-3">
                                    <span class="material-icons text-3xl text-slate-300">search_off</span>
                                </div>
                                <h3 class="text-slate-800 font-bold">ไม่พบข้อมูลโซนลานจอด</h3>
                                <span
                                    class="text-slate-400 text-sm mt-1">ลองเปลี่ยนเงื่อนไขการกรองหรือคำค้นหาใหม่</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-parking-zone *ngIf="isModalOpen" [data]="selectedItem" (close)="closeModal()"
        (saveSuccess)="onRefresh()"></app-modal-parking-zone>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>